// studentService

import api from '../api/api';
import { Student } from '../types';

export const getStudents = async (
  schoolId?: number, 
  skip?: number, 
  limit?: number,
  classLevel?: string
): Promise<Student[]> => {
  const params: any = {};
  if (schoolId) params.school_id = schoolId;
  if (skip !== undefined) params.skip = skip;
  if (limit !== undefined) params.limit = limit;
  if (classLevel) params.class_level = classLevel;
  
  const response = await api.get('/students/', { params });
  return response.data as Student[];
};

export const getUnlinkedStudents = async (schoolId: number): Promise<Student[]> => {
  const response = await api.get('/students/unlinked', { params: { school_id: schoolId } });
  return response.data as Student[];
};

export const onboardStudent = async (studentId: number, data: { username: string; email: string; password: string }) => {
  const response = await api.post(`/students/${studentId}/onboard`, data);
  return response.data;
};

export const getStudent = async (studentId: number): Promise<Student> => {
  const response = await api.get(`/students/${studentId}`);
  return response.data as Student;
};

export const getStudentByUserId = async (userId: number): Promise<Student> => {
  const response = await api.get(`/students/by_user/${userId}`);
  return response.data as Student;
};
